import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Link } from 'react-router-dom'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Header from '../../components/Header'
import Page from '../../components/Page'
import Paginator from '../../components/Paginator'
import Sorter, { SortControl } from '../../components/Sorter'
import StickyTable from '../../components/StickyTable'
import { useQsFilters } from '../../hooks/filters'
import { Video } from '../../types'
import { useDeleteVideo, useVideoList } from '../../hooks/video'
import { COLORE_MAP, FORMATO_MAP } from '../../consts'

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? '-id',
})

export default function VideoList() {
  const { filters, uiFilters, setFiltersDebounced, setFilters } =
    useQsFilters(initFilters)

  const { data } = useVideoList(filters)
  const deleteVideo = useDeleteVideo()
  const [modalRm, modalRmActions] = useModalTrigger<Video>()

  return (
    <Page padded>
      <Header>
        <div className="d-flex align-items-end">
          <h2 className="m-0">Video</h2>
          <div className="counter ms-2 mb-1">
            <small>
              {data!.count}
              {' / '}
              {data!.total_count}
            </small>
          </div>
        </div>
        <Link className="btn btn-primary" to="/video/new">
          <i className="bi bi-plus-circle me-2"></i> Aggiungi
        </Link>
      </Header>
      <div className="d-flex justify-content-between mt-3 mb-3 align-items-center">
        <input
          placeholder="Cerca"
          className="form-control w-auto"
          type="text"
          value={uiFilters.search}
          onChange={(e) =>
            setFiltersDebounced({ search: e.target.value, page: 1 })
          }
        />
      </div>
      <StickyTable className="flex-1">
        <thead>
          <Sorter
            value={uiFilters.ordering}
            onSortChange={(ordering) =>
              setFilters({
                ordering,
                page: 1,
              })
            }
          >
            <tr>
              <th>#</th>
              <th>
                <div className="d-flex align-items-center">
                  Titolo
                  <SortControl field="titolo" />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  Fonti
                  
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  Colore
                  <SortControl field="colore" />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  Formato
                  <SortControl field="formato" />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  Anno
                  <SortControl field="anno" />
                </div>
              </th>
              <th>Immagine</th>
            </tr>
          </Sorter>
        </thead>
        <tbody>
          {data!.results.map((video) => (
            <tr key={video.id}>
              <td>{video.id}</td>
              <td>
                <Link to={`/video/${video.id}`}>{video.titolo}</Link>
              </td>
              <td>{video.fonti_data.map((f) => f.nome).join(', ')}</td>
              <td>{COLORE_MAP[video.colore]}</td>
              <td>{FORMATO_MAP[video.formato]}</td>
              <td>{video.anno}</td>
              <td>
                {video.immagine && (
                  <img src={video.immagine} alt={video.titolo} width="100" />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </StickyTable>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il video
              {modalRm.value.titolo} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteVideo.isLoading}
            onClick={async () => {
              await deleteVideo.mutateAsync(modalRm.value!.id)
              modalRmActions.close()
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
      <div className="position-relative">
        <Paginator
          count={data!.count}
          currentPage={uiFilters.page}
          goToPage={(page) => setFilters({ page })}
        />
      </div>
    </Page>
  )
}
